/**
 * Checks if input string matches ID3 Vehicle key
 * @param {String} source
 * @return {Boolean}
 */
 export const getIsId3Vehicle = source => source === 'VTP';
